import { FullPageEmbeddedMediaElement, Link, Stack, Text } from '@/components';
import Play from '@/assets/play.svg';
import classNames from 'classnames';
import { useState } from 'react';
import { ImageModel, LinkModel, ModuleBaseNameProps } from '@/types';

export type FullPageVideoSlideElementModel = {
  coverImage?: ImageModel;
  ctaLink?: LinkModel;
  text?: string;
  textPosition?: 'Left' | 'Right';
  theme?: 'Light' | 'Dark' | '';
  title?: string;
  videoEmbedCode?: string;
  videoUrl?: string;
} & ModuleBaseNameProps;

const FullPageVideoSlideElement = ({
  videoEmbedCode,
  coverImage,
  videoUrl,
  textPosition,
  title,
  text,
  ctaLink,
}: FullPageVideoSlideElementModel) => {
  const [hideContent, setHideContent] = useState(false);
  const [removeContent, setRemoveContent] = useState(false);

  const setPlayClicked = () => {
    setHideContent(true);
    setTimeout(() => {
      setRemoveContent(true);
    }, 1000);
  };

  return (
    <div className="full-page-video-slide-element relative h-full w-full">
      {videoEmbedCode && coverImage && (
        <FullPageEmbeddedMediaElement
          videoEmbedCode={videoEmbedCode}
          videoUrl={videoUrl}
          coverImage={{ desktopImage: coverImage, mobileImage: coverImage }}
          className="h-full w-full"
          playIcon={
            <div className="flex h-12 w-22 items-center justify-center rounded-xl border border-white bg-black/50 transition hover:bg-white/30">
              <Play className="h-7 w-7 fill-white" />
            </div>
          }
          onPlayClicked={setPlayClicked}
        />
      )}

      <Stack
        className={classNames(
          'module-base-light absolute bottom-16 w-full transition-opacity duration-1000',
          hideContent && 'opacity-0',
          removeContent && 'hidden',
        )}
      >
        <div className={classNames('container flex', textPosition === 'Right' ? 'justify-end' : 'justify-start')}>
          <div className="color-from-bg flex flex-col lg:w-2/3 xl:w-1/2">
            {title && (
              <Text tag="h1" className="text-[35px] leading-10 xl:text-[70px] xl:leading-[74px]">
                {title}
              </Text>
            )}
            {text && (
              <Text className="mt-4 text-base leading-[22px] xl:mt-8" dangerouslySetInnerHTML={{ __html: text }} />
            )}
            {ctaLink && (
              <div>
                <Link animate className="btn secondary btn-from-bg mt-4 xl:mt-8" link={ctaLink} />
              </div>
            )}
          </div>
        </div>
      </Stack>
    </div>
  );
};

export default FullPageVideoSlideElement;
